<page-load-header *ngIf="!initialized && !editError"></page-load-header>

<ng-container *ngIf="editError">
  <div *ngIf="conference" class="mt-3">
    <h3 class="text-center">{{ conference.name }}</h3>
      <h5 class="text-center">{{ conference.startDate | date: 'shortDate' }} - {{ conference.endDate | date: 'shortDate' }}</h5>
      <h5 class="text-center">Group Registration</h5>
  </div>
  <div class="text-center">
    <h3 class="mt-3">{{ editError }}</h3>
  </div>
</ng-container>

<div *ngIf="initialized && conference" class="custom-container">
  <div class="w-lg-90 mx-lg-auto">
    <h3 class="text-center mt-3">{{ conference.name }}</h3>
    <h5 class="text-center">{{ conference.startDate | date: 'shortDate' }} - {{ conference.endDate | date: 'shortDate' }}</h5>
    <h5 class="text-center">Group Registration</h5>

    <div class="alert alert-warning"><strong>Need an IRS Form W9? </strong> <a href="../../../assets/W9.pdf"> Download Here</a></div>

    <div class="mt-5 mb-5">
      <div *ngIf="hasGroupDiscounts" class="mb-2">
        <a role="button" class="text-primary cursor-pointer" (click)="openGroupDiscountDetails()">Group Discount Details</a>
      </div>
      <div *ngIf="errorMessage" class="alert alert-primary" role="alert">
        {{ errorMessage }}
      </div>
      <form class="form" #theForm="ngForm" novalidate>
        <div class="card bg-soft-light mb-4">
          <div class="card-header">
            <div class="row">
              <div class="col">
                <h5>Registrants ( {{ groupModel.registrantPurchases.length }} )</h5>
              </div>
              <div class="col text-right">
                <h5>{{ totals.invoicedAmount | currency: currencyCode:'symbol' }}</h5>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div *ngIf="groupModel.registrantPurchases.length == 0" class="">
              Click below to add your first registrant.
            </div>
            <table *ngIf="groupModel.registrantPurchases.length > 0" class="bg-white table mobile-table table-bordered-outside table-hover mb-0">
              <thead class="bg-light">
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Member</th>
                  <th>CEUs</th>
                  <th>Add-Ons</th>
                  <th>Workshops</th>
                  <th class="text-right">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let registrant of groupModel.registrantPurchases; let i = index">
                  <td>{{registrant.firstName + ' ' + registrant.lastName}}<br/><em>{{registrant.package.category}} > {{registrant.package.name}}</em></td>
                  <td>{{registrant.email}}</td>
                  <td class="text-center" *ngIf="registrant.isMember"><span class="mobile-grid-label">Member</span><i class="fas fa-check-circle text-success"></i></td>
                  <td class="text-center" *ngIf="!registrant.isMember"><span class="mobile-grid-label">Member</span><i class="fas fa-times-circle text-danger"></i></td>
                  <td class="text-center" *ngIf="(registrant.purchaseCEUs || !registrant.package.ceUsAreExtra) && !registrant.registrantPurchasedCEUsSeparately"><span class="mobile-grid-label">CEUs</span><i class="fas fa-check-circle text-success"></i></td>
                  <td class="text-center" *ngIf="(!registrant.purchaseCEUs && registrant.package.ceUsAreExtra) || registrant.registrantPurchasedCEUsSeparately"><span class="mobile-grid-label">CEUs</span><i class="fas fa-times-circle text-danger"></i></td>
                  <td class="text-center" *ngIf="registrant.selectedAddOns?.length > 0"><span class="mobile-grid-label">Add-Ons</span>{{registrant.selectedAddOns.length}}</td>
                  <td class="text-center" *ngIf="registrant.selectedAddOns?.length == 0"><span class="mobile-grid-label">Add-Ons</span> - </td>
                  <td class="text-center" *ngIf="registrant.selectedEventAddons?.length > 0"><span class="mobile-grid-label">Workshops</span>{{registrant.selectedEventAddons.length}}</td>
                  <td class="text-center" *ngIf="registrant.selectedEventAddons?.length == 0"><span class="mobile-grid-label">Workshops</span> - </td>
                  <td class="text-right mobile-force-left" style="min-width: 130px">
                    <button type="button" class="btn btn-icon btn-danger transition-3d-hover" (click)="editRegistrant(registrant.tempRowNumber)">
                      <span class="fas fa-pencil btn-icon__inner"></span>
                    </button>
                    <button *ngIf="i > 0 || groupModel.registrantPurchases.length > 1" type="button" class="btn btn-icon btn-danger transition-3d-hover ml-1" (click)="removeRegistrant(registrant.tempRowNumber, registrant.hasAdditionalTransactionsForUserPackage)">
                      <span class="fas fa-trash btn-icon__inner"></span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer">
            <a role="button" class="text-primary cursor-pointer" (click)="addRegistrant()">Add Registrant</a>
          </div>
        </div>
        

        <div class="form-group">
          <label for="inputAddress">Payment Method</label>
          <select class="form-control" [disabled]="linkUniqueId" required [(ngModel)]="groupModel.isCreditCard" name="isCreditCard">
            <option [ngValue]="null">Please Choose...</option>
            <option [ngValue]="true">Credit Card</option>
            <option [ngValue]="false">Check/Purchase Order</option>
          </select>
          <div class="invalid-message">Payment Method is Required</div>
        </div>

        <div class="form-group mt-3">
          <label for="inputAddress2">Promo Code</label>
          <div class="input-group mb-3">
            <input type="text" class="form-control" name="promoCode" [(ngModel)]="groupModel.promoCode" aria-describedby="basic-addon2" />
            <div class="input-group-append">
              <button class="btn btn-primary" type="button" (click)="applyPromoCode()">Apply</button>
            </div>
          </div>
          <div *ngIf="promoError" class="invalid-message-visible">
            <div>{{ promoError }}</div>
          </div>
        </div>

        <ng-container *ngIf="groupModel.isCreditCard">
          <div class="form-group mt-3">
            <label for="inputAddress2">Card Number</label>
            <input type="text" required [(ngModel)]="cardNumber" name="cardNumber" class="form-control" />
            <div class="invalid-message">Card Number is Required</div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-5">
              <label for="inputCity">Expiration Month</label>
              <select class="form-control" [(ngModel)]="expMo" name="expMo" required>
                <option value="1">01 - January</option>
                <option value="2">02 - February</option>
                <option value="3">03 - March</option>
                <option value="4">04 - April</option>
                <option value="5">05 - May</option>
                <option value="6">06 - June</option>
                <option value="7">07 - July</option>
                <option value="8">08 - August</option>
                <option value="9">09 - September</option>
                <option value="10">10 - October</option>
                <option value="11">11 - November</option>
                <option value="12">12 - December</option>
              </select>
              <div class="invalid-message">Month is Required</div>
            </div>
            <div class="form-group col-md-5">
              <label for="inputCity">Expiration Year</label>
              <select class="form-control" [(ngModel)]="expYr" name="expYr" required>
                <option value="2023">2023</option>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
                <option value="2026">2026</option>
                <option value="2027">2027</option>
                <option value="2028">2028</option>
                <option value="2029">2029</option>
                <option value="2030">2030</option>
                <option value="2031">2031</option>
                <option value="2032">2032</option>
                <option value="2033">2033</option>
                <option value="2034">2034</option>
              </select>
              <div class="invalid-message">Year is Required</div>
            </div>
            <div class="form-group col-md-2">
              <label for="cvv">CVV</label>
              <input type="text" class="form-control" id="cvv" [(ngModel)]="cvv" name="cvv" required />
              <div class="invalid-message">CVV is Required</div>
            </div>
          </div>
        </ng-container>
        <div *ngIf="!groupModel.isCreditCard" class="form-group mt-5">
          <label for="inputAddress2">Name (Individual or organization)</label>
          <input type="text" class="form-control" required id="personName" [(ngModel)]="groupModel.name" name="name" placeholder="Acme School District" />
          <div class="invalid-message">Name is Required</div>
        </div>
        <div *ngIf="!groupModel.isCreditCard" class="form-group mt-5">
          <label for="contactPhoneNumber">Contact Phone Number</label>
          <input type="text" class="form-control" required id="contactPhoneNumber" [(ngModel)]="groupModel.contactPhoneNumber" name="contactPhoneNumber" placeholder="555-555-5555" />
          <div class="invalid-message">Phone Number is Required</div>
        </div>

        <div class="form-group mt-5">
          <label for="inputAddress2">Receipt/Invoice Email</label>
          <input type="email" class="form-control" [disabled]="linkUniqueId" id="contactEmail" required email pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" [(ngModel)]="groupModel.contactEmail" name="contactEmail" placeholder="ap@company.com" />
          <div class="invalid-message">Email is Required</div>
        </div>
        <div *ngIf="!groupModel.isCreditCard" class="form-group mt-5">
          <label for="inputAddress2">PO Number (Optional - shows on invoice. Can be added at a later date.)</label>
          <input type="text" class="form-control" id="PoNumber" [(ngModel)]="groupModel.poNumber" name="poNumber" placeholder="PO-20102" />
        </div>
        <div *ngIf="totals.groupDiscountAmount || totals.promoCodeDiscountAmount" class="mt-2 mb-2 text-right">
          <div>
            Subtotal: {{(totals.invoicedAmount + totals.groupDiscountAmount + totals.promoCodeDiscountAmount) | currency: currencyCode:'symbol'}}
          </div>
          <div *ngIf="totals.groupDiscountAmount"> 
            Group Discount: -{{totals.groupDiscountAmount | currency: currencyCode:'symbol'}}
          </div>
          <div *ngIf="totals.promoCodeDiscountAmount"> 
            Promo Code Discount: -{{totals.promoCodeDiscountAmount | currency: currencyCode:'symbol'}}
          </div>
        </div>
        <div *ngIf="errorMessage" class="alert alert-primary mt-2" role="alert">
          {{ errorMessage }}
        </div>
        <button type="submit" class="btn btn-success btn-block" (click)="purchasePackageClicked()" [promiseBtn]="submitComplete">{{linkUniqueId ? 'Update PO' : 'Register'}} ({{ totals.invoicedAmount | currency: currencyCode:'symbol' }})</button>
      </form>
    </div>
  </div>
</div>
